import { spotify_auth } from "./spotify-package";

const url = process.env.REACT_APP_API_URL || "";
const clientId = process.env.REACT_APP_SPOTIFY_CLIENT_ID || "";
let redirectUri = process.env.REACT_APP_SPOTIFY_REDIRECT_URI || "";
const scopes = process.env.REACT_APP_SPOTIFY_SCOPE || "";

export {url, clientId, redirectUri, scopes};